__turbopack_context__.v({
  "offerTileBreakpointStyles": "styles-module__g0JGGq__offerTileBreakpointStyles",
  "offerTileButtonsContainer": "styles-module__g0JGGq__offerTileButtonsContainer",
  "offerTileButtonsContainerInline": "styles-module__g0JGGq__offerTileButtonsContainerInline",
  "offerTileContainer": "styles-module__g0JGGq__offerTileContainer",
  "offerTileLinkContainer": "styles-module__g0JGGq__offerTileLinkContainer",
  "offerTileOriginalPrice": "styles-module__g0JGGq__offerTileOriginalPrice",
  "offerTilePrice": "styles-module__g0JGGq__offerTilePrice",
  "offerTilePriceContainer": "styles-module__g0JGGq__offerTilePriceContainer",
  "offerTileRow": "styles-module__g0JGGq__offerTileRow",
  "offerTileText": "styles-module__g0JGGq__offerTileText",
  "offerTileTextContainer": "styles-module__g0JGGq__offerTileTextContainer",
  "offerTileTitle": "styles-module__g0JGGq__offerTileTitle",
  "purchaseableOfferTileText": "styles-module__g0JGGq__purchaseableOfferTileText",
  "purchaseableOfferTitle": "styles-module__g0JGGq__purchaseableOfferTitle",
  "rejectedOfferTitle": "styles-module__g0JGGq__rejectedOfferTitle",
});
